// extracted by mini-css-extract-plugin
export default {"DownloadAppBadges":"mmxgWUJv1EjzEYvbvJpq"};